import { RequestEvent } from 'state-data';

export class AccountNumberRegistrationEvent extends RequestEvent {
  constructor(public accountNumber: string) {
    super();
  }
}
